import { createStaffRequest, fetchStaffRequest, updateStaffRequest, fetchStaffsRequest } from '../api/index'
import { handleErrorRequest } from '../helpers/api'
import _ from 'lodash'

export const CREATE_STAFF_ATTEMPT = 'staffs/CREATE_STAFF_ATTEMPT'
export const CREATE_STAFF_SUCCESS = 'staffs/CREATE_STAFF_SUCCESS'
export const CREATE_STAFF_FAILURE = 'staffs/CREATE_STAFF_FAILURE'

export const UPDATE_STAFF_ATTEMPT = 'staffs/UPDATE_STAFF_ATTEMPT'
export const UPDATE_STAFF_SUCCESS = 'staffs/UPDATE_STAFF_SUCCESS'
export const UPDATE_STAFF_FAILURE = 'staffs/UPDATE_STAFF_FAILURE'

export const FETCH_STAFF_ATTEMPT = 'staffs/FETCH_STAFF_ATTEMPT'
export const FETCH_STAFF_SUCCESS = 'staffs/FETCH_STAFF_SUCCESS'
export const FETCH_STAFF_FAILURE = 'staffs/FETCH_STAFF_FAILURE'

export const FETCH_STAFFS_ATTEMPT = 'staffs/FETCH_STAFFS_ATTEMPT'
export const FETCH_STAFFS_SUCCESS = 'staffs/FETCH_STAFFS_SUCCESS'
export const FETCH_STAFFS_FAILURE = 'staffs/FETCH_STAFFS_FAILURE'

export const SET_CURRENT_STAFF = 'staffs/SET_CURRENT_STAFF'
export const SET_STAFFS = 'staffs/SET_STAFFS'

export const RESET_STATE = 'staffs/RESET_STATE'
export const ACTIVE_STAFFS = 'staffs/ACTIVE_STAFFS'

const createStaffAttempt = () => ({ type: CREATE_STAFF_ATTEMPT })
const createStaffSuccess = () => ({ type: CREATE_STAFF_SUCCESS })
const createStaffFailure = (failMessage) => ({ type: CREATE_STAFF_FAILURE, failMessage })

const updateStaffAttempt = () => ({ type: UPDATE_STAFF_ATTEMPT })
const updateStaffSuccess = () => ({ type: UPDATE_STAFF_SUCCESS })
const updateStaffFailure = (failMessage) => ({ type: UPDATE_STAFF_FAILURE, failMessage })

const fetchStaffAttempt = () => ({ type: FETCH_STAFF_ATTEMPT })
const fetchStaffSuccess = () => ({ type: FETCH_STAFF_SUCCESS })
const fetchStaffFailure = (failMessage) => ({ type: FETCH_STAFF_FAILURE, failMessage })

const fetchStaffsAttempt = () => ({ type: FETCH_STAFFS_ATTEMPT })
const fetchStaffsSuccess = () => ({ type: FETCH_STAFFS_SUCCESS })
const fetchStaffsFailure = (failMessage) => ({ type: FETCH_STAFFS_FAILURE, failMessage })

const setCurrentStaff = (currentStaff) => ({type: SET_CURRENT_STAFF, currentStaff})

const setStaffs = (staffs) => ({type: SET_STAFFS, staffs})

const activeStaffs = () => ({type: ACTIVE_STAFFS})

const createStaff = ({dealer_id, data}) => (dispatch, getState) => {
  dispatch(createStaffAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return createStaffRequest({data: { staff: data }, dealer_id, jwt}).then(({ response, error }) => {
    if (response) {
      dispatch(createStaffSuccess())
      return Promise.resolve(response.data)
    } else {
      dispatch(createStaffFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const fetchStaff = ({dealer_id, staff_id}) => (dispatch, getState) => {
  dispatch(fetchStaffAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return fetchStaffRequest({staff_id, dealer_id, jwt}).then(({ response, error }) => {
    if (response) {
      dispatch(fetchStaffSuccess())
      dispatch(setCurrentStaff(response.data))
    } else {
      dispatch(fetchStaffFailure(handleErrorRequest(error)))
    }
  })
}

const fetchStaffs = ({dealer_id, active}) => (dispatch, getState) => {
  dispatch(fetchStaffsAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return fetchStaffsRequest({dealer_id, jwt, active}).then(({ response, error }) => {
    if (response) {
      dispatch(fetchStaffsSuccess())
      dispatch(setStaffs(response.data))
    } else {
      dispatch(fetchStaffsFailure(handleErrorRequest(error)))
    }
  })
}

const updateStaff = ({dealer_id, staff_id, data}) => (dispatch, getState) => {
  dispatch(updateStaffAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return updateStaffRequest({dealer_id, staff_id, data: { staff: data }, jwt}).then(({ response, error }) => {
    if (response.status>=200 && response.status<=299 ) {
      dispatch(updateStaffSuccess())
      return Promise.resolve(response.data)
    } else if (response){
      dispatch(updateStaffFailure(handleErrorRequest(response)))
      return Promise.reject(response)
    } else {
      dispatch(updateStaffFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const resetState = () => ({ type: RESET_STATE })

export const actions = {
  createStaffAttempt,
  createStaffSuccess,
  createStaffFailure,
  createStaff,
  fetchStaffAttempt,
  fetchStaffSuccess,
  fetchStaffFailure,
  fetchStaff,
  fetchStaffsAttempt,
  fetchStaffsSuccess,
  fetchStaffsFailure,
  fetchStaffs,
  setStaffs,
  updateStaffAttempt,
  updateStaffSuccess,
  updateStaffFailure,
  updateStaff,
  setCurrentStaff,
  activeStaffs,
  resetState
}

const STAFF_ACTION_HANDLERS = {
  [CREATE_STAFF_ATTEMPT]: (state, action) =>
    ({ ...state, submittingStaff: true, failSubmitStaff: null, successSubmitStaff: false }),
  [CREATE_STAFF_SUCCESS]: (state, action) =>
    ({ ...state, submittingStaff: false, failSubmitStaff: null, successSubmitStaff: true }),
  [CREATE_STAFF_FAILURE]: (state, action) =>
    ({ ...state, submittingStaff: false, failSubmitStaff: action.failMessage, successSubmitStaff: false }),

  [UPDATE_STAFF_ATTEMPT]: (state, action) =>
    ({ ...state, submittingStaff: true, failSubmitStaff: null, successSubmitStaff: false }),
  [UPDATE_STAFF_SUCCESS]: (state, action) =>
    ({ ...state, submittingStaff: false, failSubmitStaff: null, successSubmitStaff: true }),
  [UPDATE_STAFF_FAILURE]: (state, action) =>
    ({ ...state, submittingStaff: false, failSubmitStaff: action.failMessage, successSubmitStaff: false }),

  [FETCH_STAFF_ATTEMPT]: (state, action) =>
    ({ ...state, fetchingStaff: true, failFetchStaff: null, successFetchStaff: false }),
  [FETCH_STAFF_SUCCESS]: (state, action) =>
    ({ ...state, fetchingStaff: false, failFetchStaff: null, successFetchStaff: true }),
  [FETCH_STAFF_FAILURE]: (state, action) =>
    ({ ...state, fetchingStaff: false, failFetchStaff: action.failMessage, successFetchStaff: false }),

  [FETCH_STAFFS_ATTEMPT]: (state, action) =>
    ({ ...state, fetchingStaffs: true, failFetchStaffs: null, successFetchStaffs: false }),
  [FETCH_STAFFS_SUCCESS]: (state, action) =>
    ({ ...state, fetchingStaffs: false, failFetchStaffs: null, successFetchStaffs: true }),
  [FETCH_STAFFS_FAILURE]: (state, action) =>
    ({ ...state, fetchingStaffs: false, failFetchStaffs: action.failMessage, successFetchStaffs: false }),
    
  [SET_CURRENT_STAFF]: (state, action) =>
    ({...state, currentStaff: action.currentStaff}),
  [SET_STAFFS]: (state, action) =>
    ({...state, staffs: action.staffs}),
  [RESET_STATE]: (state, action) =>
  ({ ...state, ...initialState, ...{staffs: state.staffs, currentStaff: state.currentStaff}}),
  [ACTIVE_STAFFS]: (state, action) =>
    ({...state, active: !state.active})

}

export const initialState = {
  submittingStaff: false,
  failSubmitStaff: null,
  successSubmitStaff: false,
  fetchingStaff: false,
  failFetchStaff: null,
  successFetchStaff: false,
  currentStaff: null,
  fetchingStaffs: false,
  failFetchStaffs: null,
  successFetchStaffs: false,
  staffs: null,
  active: true
}

export default function staffReducer(state = initialState, action) {
  const handler = STAFF_ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}